import { FormGroup } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const StyledFormGroup = styled(FormGroup)<{ $error?: string }>`
    .rf-form-group__message {
        ${({ $error }) => !$error && 'margin-top: 0 !important;'}
    }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type='number'] {
        -moz-appearance: textfield;
    }
`;

const Option = styled('div')`
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
`;

export const PreloaderOption = styled(Option)`
    height: 36px;
`;
